import { useQuery } from '@tanstack/react-query';
import * as authApi from '../api/auth';

/**
 * Public sign-in options (currently: is self-registration open?). Optimistic
 * about registration until the answer arrives so the link does not flash in
 * after first paint on instances where it is on; a disabled instance simply
 * never shows it.
 */
export function useAuthOptions() {
  const q = useQuery({
    queryKey: ['auth-options'],
    queryFn: authApi.getAuthOptions,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return {
    registrationEnabled: q.data?.registration_enabled ?? false,
    isLoading: q.isLoading,
  };
}
